<template>
    <div class="totales-resumen">
        <table style="width:100%;" id="resumenTotal">
            <tr class="resumen_subtotal">
                <td style=" width: 70px;">Subtotal:</td>
                <td></td>
                <td style="text-align: right;font-weight: bold; color: #00aa00;">
                    ${{ form.subtotal | formatMoney }}
                    <!-- <input type="hidden" class="form-control" v-model="form.subtotal" /> -->
                </td>
            </tr>
            <tr v-if="proptaxShow == 1 && taxesResumen.length > 0">
                <td colspan="3" style="border-top: 1px solid #dedede; padding:0px;"></td>
            </tr>
            <tr v-if="proptaxShow == 1 && taxesResumen.length > 0" class="resumen_tax">
                <td style=" width: 70px; vertical-align: top;"></td>
                <td colspan="2" style="text-align: right;">
                    <table style="width:100%;" border="0" v-if="form.totaltax > 0" id="resumenTax">
                        <tr v-for="(iva, index) in taxesResumen" :key="index">
                            <td colspan="2">
                                <table width="100%" v-if="iva.total > 0">
                                    <tr>
                                        <td align="left">
                                            <div style="padding-right: 10px;">
                                                <b>
                                                    <span>{{ iva.name }}</span>
                                                    ({{ iva.porcentaje }}%)
                                                </b>
                                            </div>
                                        </td>
                                        <td align="right">
                                            ${{ iva.total | formatMoney }}
                                        </td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                        <tr style="display:none;">
                            <td colspan="2" style="border-bottom: 1px solid #dedede"></td>
                        </tr>
                    </table>
                </td>
            </tr>
            <tr v-if="form.totaltax > 0" style="display:none;" class="resumen_tax">
                <td style=" width: 70px; vertical-align: top;">Taxes:</td>
                <td colspan="2" style="text-align: right;"><b>${{ form.totaltax | formatMoney }}</b></td>
            </tr>
            <tr>
                <td colspan="3" style="border-bottom: 1px solid #dedede; padding:0px;"></td>
            </tr>
            <tr class="resumen_discount">
                <td style="padding:10px 0;">Discount:</td>
                <td style="padding:10px 0;width: 200px;">
                    <input type="text" :class="['form-control', (disabledStatus) ? 'disabled' : '']"
                        :disabled="disabledStatus"
                        style="text-align: right; width:80px;display:inline-block; margin-right: 10px;"
                        placeholder="E.g. 1.00" v-model="form.discount_mount" step="0.01" min="0" max="9999999.99"
                        maxlength="11" @keypress="isInteger" @change="vDiscount" />
                    <div class="form-check form-check-inline">
                        <label class="form-check-label">
                            <input class="form-check-input" type="radio" v-model="form.discount_type"
                                :disabled="disabledStatus" :value="2" /> $
                        </label>
                    </div>
                    <div class="form-check form-check-inline">
                        <label class="form-check-label">
                            <input class="form-check-input" type="radio" v-model="form.discount_type"
                                :disabled="disabledStatus" :value="1" /> %
                        </label>
                    </div>
                </td>
                <td class="discountTotal" :rowspan="(form.discount_total > 0) ? 2 : 1">
                    <b>${{ (form.discount_total * -1) | formatMoney }}</b>
                </td>
            </tr>
            <tr v-if="form.discount_total > 0" class="description_discount">
                <td colspan="2" class="nameDiscount">
                    <discount-text :value="form.discount_name" :limit="20" :limitType="'words'"
                        :placeholder="'Discount name or description (optional)'" :readonly="disabledStatus"
                        :editorClass="'form-control discount_text '" @input="responseDiscounText"
                        :emitOnLimitReached="true"></discount-text>
                    <!--
                    <textarea placeholder="Discount name or description (optional)" class="form-control"
                        style="height: 70px; display: inline-block;width: 280px;" v-model="form.discount_name"
                        maxlength="101" @keyup="lengMax($event, 100)" @keypress="noEnter" @change="setUpdate"></textarea>
                    <span class="maxSize">
                        {{ (form.discount_name != null) ? form.discount_name.length : 0 }}/100
                    </span>
                    -->
                </td>
            </tr>
            <tr>
                <td colspan="3" style="border-top: 1px solid #dedede; padding:0px;"></td>
            </tr>
            <tr class="resumen_total">
                <td colspan="2" style="width: 70px;font-weight: bold;font-size: 18px;">
                    Total:
                </td>
                <td id="total" style="">
                    ${{ form.total | formatMoney }}
                    <!-- <input type="hidden" class="form-control" v-model="form.total" /> -->
                </td>
            </tr>
        </table>
    </div>
</template>
<script>
import RichTextEditor from './../../RichTextEditor.vue'
export default {
    props: [
        "controlLoad",
        "propForm",
        "propItemsprod",
        "proptaxShow",
        "propgroupShow",
        "propTaxesResumen",
        "propdisabledSteps",
    ],
    components: {
        "discount-text": RichTextEditor,
    },
    data() {
        return {
            form: {
                subtotal: 0,
                discount_type: 2,
                discount_mount: 0.00,
                discount_total: 0.00,
                discount_name: '',
                total: 0,
                totaltax: null,
            },
            disabledStatus: this.propdisabledSteps?.customer,
            itemProducts: this.propItemsprod,
            taxesResumen: this.propTaxesResumen,
            createdFinish: false,
            debounceTimer: 0,
        };
    },
    methods: {
        isEmptyNaN(val) {
            if (isNaN(val)) { return true; }
            else if (val == null) { return true; }
            else if (val == '') { return true; }
            else { return false; }
        },
        isInteger(e) {
            var code = (e.which) ? e.which : e.keyCode;
            if ((code >= 48 && code <= 57) || code == 46) { // is a number.
                return true;
            } else { // other keys.
                // console.log('other keys', code);
                return e.preventDefault();
            }
        },
        noEnter(e) {
            var code = (e.which) ? e.which : e.keyCode;
            if (code == 13) {
                return e.preventDefault();
            }
        },
        lengMax(e, limit) {
            if (e.target.value.length > limit) {
                e.target.value = e.target.value.slice(0, limit);
            }
        },
        v2DecimalMenorAsubTotal(e){
            clearTimeout(this.debounceTimer);
            // Espera 1000 ms sin escribir para ejecutar
            let valor = e.target.value
            this.debounceTimer = setTimeout(() => { this.validAmountDiscount(valor);}, 1000);
        },
        validAmountDiscount(value){
            let valor = value.trim().replace(',', '.');
            const regex = /^\d{1,9}(\.\d{1,2})?$/;
            const valorFloat = parseFloat(valor || '0');
            if(!regex.test(valor) || valor < 0){
                let msj = "Incorrect amount, you may be adding disallowed symbology.";
                this.$emit('setAlertError', msj);
            }
            if (valorFloat >= this.form.subtotal) {
                this.form.discount_mount = 0;
                let msj = "Discount cannot be greater than or equal to the subtotal.";
                this.$emit('setAlertError', msj);
            }
        },
        vDiscount(e) {
            let t = this;
            if (t.isEmptyNaN(e.target.value)) { e.target.value = '0.00'; }
            //.replace(/,/g, ".")
            e.target.value = parseFloat(e.target.value).toFixed(2);
            // .toString()
            // .replace(/\B(?=(\d{3})+(?!\d))/g, "");
            let val = e.target.value;
            let valResult = val;
            let msj = '';
            let validInt = new RegExp(/^[0-9.]+$/);
            // si es diferente de numero , retornar cero
            // console.log('vDiscount', val)
            if (!validInt.test(val)) {
                if (val != null && val != '') {
                    msj = "Discount, only numbers allowed.";
                }
                valResult = 0;
            }
            // si es NaN
            else if (t.isEmptyNaN(val)) {
                msj = "Incorrect amount, you may be adding disallowed symbology.";
                valResult = 0;
            }
            // si es menor de cero, retorna cero
            else if (val < 0) {
                msj = "Discount cannot be less than zero";
                valResult = 0;
            }
            //validaciones donde descuento es porcentaje y es mayor de 99.99, retornar cero
            else if (t.form.discount_type == 1 && val > 0 && val > 99.99) {
                msj = "Discount cannot be greater than 99.99%";
                valResult = 0;
            }
            // validaciones siendo un monto y si es mayor a subtotal, retornar cero
            else if (t.form.discount_type == 2 && val > 0 && parseInt(val) >= parseInt(t.form.subtotal)) {
                msj = "Discount cannot be greater than or equal to the subtotal.";
                valResult = 0;
            }
            if (msj.length > 0) { this.$emit('setAlertError', msj); }
            t.form.discount_mount = Number(valResult).toFixed(2);
            e.target.value = t.form.discount_mount;
            t.total();
            return t.form.discount_mount;
        },
        showResumenTax(itemProducts, valDiscount, subtotal) {
            // console.log('showResumenTax')
            let t = this;
            //reiniciar totales de tax a cero
            if (t.taxesResumen.length > 0) {
                for (let e in t.taxesResumen) {
                    t.taxesResumen[e].total = 0;
                }
            }
            // calcular totales
            let obj = itemProducts;
            // indexar taxesResumen por id (solo una vez)
            const taxesIndex = {};
            for (const tax of t.taxesResumen) {
                taxesIndex[tax.id] = tax;
            }
            for (const item of obj) {
                // si es grupo o no tiene model salir del ciclo
                if (!item || !item.model) continue;
                const model = item.model;
                const taxOpc = model.taxOpc;
                if (!taxOpc || taxOpc == 0) continue;
                const taxResumen = taxesIndex[taxOpc.id];
                if (!taxResumen) continue;
                let unitcost = model.unitcost;
                const qty = model.qty;
                const valTax = taxOpc.name;
                if (valDiscount > 0) {
                    const defragDiscount = (unitcost / subtotal) * 100;
                    const defragDiscVal = (valDiscount * defragDiscount) / 100;
                    unitcost -= defragDiscVal;
                }
                const precioTotal = unitcost * qty;
                const importeTax = (precioTotal * valTax) / 100;
                if (!t.isEmptyNaN(importeTax)) {
                    taxResumen.total = (
                        parseFloat(taxResumen.total) + importeTax
                    ).toFixed(2);
                }
            }
            /*for (let i in obj) {
                if (obj[i].model.taxOpc != 0) {
                    if (t.taxesResumen.length > 0) {
                        for (let e in t.taxesResumen) {
                            if (t.taxesResumen[e].id == obj[i].model.taxOpc.id) {
                                let unitcost = obj[i].model.unitcost;
                                let qty = obj[i].model.qty;
                                let valTax = obj[i].model.taxOpc.name;
                                if (valDiscount > 0) {
                                    //calculamos el valor en % equivalente al subtotal
                                    let defragDiscount = (unitcost / subtotal) * 100;
                                    let defragDiscVal = valDiscount * defragDiscount / 100;
                                    // console.log('descuento en producto', defragDiscVal)
                                    unitcost = unitcost - defragDiscVal
                                    // console.log('new unitcost', unitcost)
                                }
                                let precioTotal = (unitcost * qty);
                                let importeTax = (precioTotal * valTax) / 100;
                                if (!t.isEmptyNaN(importeTax)) {
                                    let TaxTotal = parseFloat(t.taxesResumen[e].total) + parseFloat(importeTax);
                                    t.taxesResumen[e].total = parseFloat(TaxTotal).toFixed(2);
                                    // console.log('taxesResumen', valTax, t.taxesResumen[e].total)
                                }
                            }
                        }
                    }
                }
            }*/
        },
        subTotal() {
            let t = this;
            if (t.itemProducts.length > 0) {
                return t.itemProducts.reduce((carry, item) => {
                    let unitcost = item?.model?.unitcost ? item.model.unitcost : 0;
                    let qty = item.model?.qty ? item.model?.qty : 0;
                    let amount = parseFloat(carry) + parseFloat(qty) * parseFloat(unitcost)
                    let stt = item.model?.prices ? item.model?.prices : 0;
                    if (t.isEmptyNaN(amount)) {
                        amount = '0.00'
                    } else {
                        amount = parseFloat(amount).toFixed(2);
                    }
                    t.form.subtotal = amount
                    // console.log(' calc subtotal', t.form.subtotal)
                    return amount
                }, 0);
            }
            else {
                t.form.subtotal = '0.00';
                // console.log('else subtotal', t.form.subtotal)
                return '0.00';
            }
        },
        discount() {
            let t = this;
            // inicializo variables a utilizar
            let discount_value = '0.00';
            let mount = parseFloat(t.form.discount_mount);
            // console.log('calcular discount', mount)
            // obtener el valor del descuento para ello
            // primero valido si el descuento es en % o $
            if (mount > 0) {
                // si descuento es mayor a cero, calculo
                if (t.form.discount_type == 1) { // porcentaje
                    discount_value = (parseFloat(t.form.subtotal) * mount) / 100;
                }
                else if (t.form.discount_type == 2) {
                    // monto
                    discount_value = mount;
                }
            }
            // valido q no sea Nan
            if (t.isEmptyNaN(discount_value)) { discount_value = '0.00'; }
            // si el calculo de descuento es igual o mayor al subtotal retorno cero o error
            if (discount_value >= parseFloat(t.form.subtotal)) { discount_value = '0.00'; }
            t.form.discount_total = parseFloat(discount_value).toFixed(2); // ajustamos decimales a 2
            // console.log('t.form.discount_total', t.form.discount_total)
            return t.form.discount_total;
        },
        totalTaxes() {
            let t = this;
            let totaltaxes = '0.00';
            if (t.proptaxShow == 1) {
                // solo si taxes esta activo, genero resumen de tax
                t.showResumenTax(t.itemProducts, t.form.discount_total, t.form.subtotal);
                if (t.taxesResumen.length > 0) {
                    for (let e in t.taxesResumen) {
                        totaltaxes = parseFloat(totaltaxes) + parseFloat(t.taxesResumen[e].total);
                        // console.log('totaltaxes +', t.taxesResumen[e].total)
                    }
                }
            }
            if (t.isEmptyNaN(totaltaxes)) { totaltaxes = '0.00'; }
            t.form.totaltax = parseFloat(totaltaxes).toFixed(2);
            // console.log('t.form.totaltax = ', t.form.totaltax)
            return t.form.totaltax;
        },
        total() {
            let t = this;
            t.subTotal();
            t.discount();
            t.totalTaxes()
            let stt = (parseFloat(t.form.subtotal) - parseFloat(t.form.discount_total) + parseFloat(t.form.totaltax));
            if (t.isEmptyNaN(stt)) { stt = '0.00'; }
            t.form.total = parseFloat(stt).toFixed(2);
            t.setUpdate(); // actualizar componente padre
            return t.form.total;
        },
        setUpdate() {
            let t = this;
            t.$emit('updateTotales', t.form);
        },
        responseDiscounText(data) {
            let t = this;
            // console.log('responseDiscounText', data)
            data = (data == null || data == undefined) ? t.form.discount_name : data;
            data = (typeof data == 'string') ? data : "";
            t.form.discount_name = data;
            t.setUpdate();
        },
    },
    watch: {
        propItemsprod: {
            handler: function (newVal) {
                let t = this;
                t.itemProducts = newVal
                setTimeout(() => { t.total(); }, 500);
                // console.log('detectando cambio en propItemsprod', newVal)
                return;
            },
            deep: true, // Necesario para observar cambios en los objetos dentro del array
            immediate: true, // Llamar al watch inmediatamente al cargar
        },
        propTaxesResumen: {
            handler: function (newVal) {
                let t = this;
                t.taxesResumen = newVal
                // setTimeout(() => {t.total();}, 500);
                // console.log('detectando cambio en propTaxesResumen', newVal)
                return;
            },
            deep: true, // Necesario para observar cambios en los objetos dentro del array
            immediate: true, // Llamar al watch inmediatamente al cargar
        },
        proptaxShow: function () {
            let t = this;
            // console.log('proptaxShow ', this.proptaxShow)
            setTimeout(() => { t.total(); }, 500);
        },
        'form.discount_mount': function () {
            let t = this;
            console.log('watch form.discount_mount', this.form.discount_mount)
            setTimeout(() => { t.total(); }, 500);
        },
        'form.discount_type': function (newVal, oldVal) {
            let t = this;
            t.form.discount_type = parseInt(newVal) || 2;
            if(newVal != oldVal){
                if(this.createdFinish){
                    t.form.discount_mount = '0.00';
                }
            }
            t.total();
        },
        'disabledStatus': function (newVal, oldVal) {
            let t = this;
            console.log('watch disabledStatus', newVal, oldVal)
        },
    },
    created() {
        // console.log('propForm ', this.propForm)
        this.form.discount_type = parseInt(this.propForm.discount_type) || 2
        this.form.discount_name = this.propForm.discount_name
        this.form.discount_total = this.propForm.discount_total
        this.form.discount_mount = this.propForm.discount_mount
        console.log('created propForm.discount_mount', this.propForm.discount_mount)
        setTimeout(() => {
            this.createdFinish= true
        }, 500);
    }
};
</script>
<style>
.quillWrapper.discount_text .ql-editor li:not(.ql-direction-rtl)::before {
    left: -5px !important;
}

.cursor-text.form-control.discount_text,
.quillWrapper.discount_text {
    margin: -0.375rem -0.75rem;
    display: inline-block;
    width: 350px;
    min-height: 70px;
    max-height: 70px;
    height: auto;
    overflow: hidden;
    overflow-y: auto;
}
</style>
